import React from "react";

const Experience = () => {
  return (
    <>
      <div className="experience-section container">
        <div className="row">
          <div className="project-text-column col-lg-12">
            <div className="text-align-center">
              <h2 className="section-heading">Experience 💼</h2>
            </div>
          </div>
        </div>
        <div className="experience-container">
          <div className="d-flex justify-content-center  flex-wrap ">
            {/* <div className="col-lg-6">
              <div className="single-exp-wrapper">
                <div className="exp-card text-left d-flex justify-content-center">
                  <div className="row">
                    <div className="exp-meta col-lg-12">
                      <img
                        src="./media/norei.gif"
                        className="job-logo"
                        alt="job"
                      />
                      <h5 className="job-client">Student Of BCA</h5>
                      <h6 className="job-tenure">Nov 2021 -  Present</h6>
                      <p className="job-tenure">Rajiv Acadmey Technlogy and managent</p>
                    </div>
                   {false &&` <div className="exp-details col-lg-8">
                      <h4 className="job-title">Fresher</h4>
                      <p className="exp-description">
                       Curruntly Studing
                      </p>
                      <h6 className="resp-heading bold">Responsibilites</h6>
                      <ul className="exp-resp">
                        <li className="responsibility">
                          Conerting the designs into working site
                        </li>
                        <li className="responsibility">
                          Cleaning existing pages and converting to newer
                          designs
                        </li>
                        <li className="responsibility">
                          Constantly delivering and receiving the feedback
                        </li>
                        <li className="responsibility">
                          Work on the feedback points
                        </li>
                        <li className="responsibility">
                          Resolve any hosting problems
                        </li>
                      </ul>
                    </div>`}
                  </div>
                </div>
              </div>
            </div> */}

<div data-aos="fade-right" className="col-sm-12 col-lg-6 px-3">
              <div className="single-exp-wrapper">
                <div className="exp-card text-left d-flex justify-content-center">
                  <div className="row">
                    <div className="exp-meta col-lg-12">
                      <img
                        src="./media/speqto.avif"
                        className="img-fluid py-4"
                        alt="job" 
                      />
                      <h5 className="job-client">Software Developer Intern</h5>
                      <h6 className="job-tenure">Apr 2023 -  September 2023</h6>
                      {/* <p className="job-tenure"> Speqto Technologies</p> */}
                      <p className="job-tenure"> Sector 62, Noida, Uttar Pradesh</p>
                    </div>
                   {false &&` <div className="exp-details col-lg-8">
                      <h4 className="job-title">Fresher</h4>
                      <p className="exp-description">
                       Curruntly Studing
                      </p>
                      <h6 className="resp-heading bold">Responsibilites</h6>
                      <ul className="exp-resp">
                        <li className="responsibility">
                          Conerting the designs into working site
                        </li>
                        <li className="responsibility">
                          Cleaning existing pages and converting to newer
                          designs
                        </li>
                        <li className="responsibility">
                          Constantly delivering and receiving the feedback
                        </li>
                        <li className="responsibility">
                          Work on the feedback points
                        </li>
                        <li className="responsibility">
                          Resolve any hosting problems
                        </li>
                      </ul>
                    </div>`}
                  </div>
                </div>
              </div>
            </div>

            <div  data-aos="fade-left" className="col-sm-12 col-lg-6 px-3">
              <div className="single-exp-wrapper">
                <div className="exp-card text-left d-flex justify-content-center">
                  <div className="row">
                    <div className="exp-meta col-lg-12">
                      <img
                        src="./media/imeet.jpg"
                        className="img-fluid py-4 w-50"
                        alt="job" 
                      />
                      <h5 className="job-client">React Js Mentor</h5>
                      <h6 className="job-tenure">June 2023 -  August 2023</h6>
                      {/* <p className="job-tenure"> Speqto Technologies</p> */}
                      <p className="job-tenure"> Mathura, Uttar Pradesh</p>
                    </div>
                   {false &&` <div className="exp-details col-lg-8">
                      <h4 className="job-title">Fresher</h4>
                      <p className="exp-description">
                       Curruntly Studing
                      </p>
                      <h6 className="resp-heading bold">Responsibilites</h6>
                      <ul className="exp-resp">
                        <li className="responsibility">
                          Conerting the designs into working site
                        </li>
                        <li className="responsibility">
                          Cleaning existing pages and converting to newer
                          designs
                        </li>
                        <li className="responsibility">
                          Constantly delivering and receiving the feedback
                        </li>
                        <li className="responsibility">
                          Work on the feedback points
                        </li>
                        <li className="responsibility">
                          Resolve any hosting problems
                        </li>
                      </ul>
                    </div>`}
                  </div>
                </div>
              </div>
            </div>

            <div data-aos="fade-right" className="col-sm-12 col-lg-6 px-3">
              <div className="single-exp-wrapper">
                <div className="exp-card text-left d-flex justify-content-center">
                  <div className="row">
                    <div className="exp-meta col-lg-12">
                      <img
                        src="./media/DT_Logo.png"
                        className="img-fluid py-4 w-50"
                        alt="job" 
                      />
                      <h5 className="job-client">Software Developer</h5>
                      <h6 className="job-tenure">January 2024 -  Present</h6>
                      {/* <p className="job-tenure"> Speqto Technologies</p> */}
                      <p className="job-tenure"> Sector 18 ,Noida, Uttar Pradesh</p>
                    </div>
                   {false &&` <div className="exp-details col-lg-8">
                      <h4 className="job-title">Fresher</h4>
                      <p className="exp-description">
                       Curruntly Studing
                      </p>
                      <h6 className="resp-heading bold">Responsibilites</h6>
                      <ul className="exp-resp">
                        <li className="responsibility">
                          Conerting the designs into working site
                        </li>
                        <li className="responsibility">
                          Cleaning existing pages and converting to newer
                          designs
                        </li>
                        <li className="responsibility">
                          Constantly delivering and receiving the feedback
                        </li>
                        <li className="responsibility">
                          Work on the feedback points
                        </li>
                        <li className="responsibility">
                          Resolve any hosting problems
                        </li>
                      </ul>
                    </div>`}
                  </div>
                </div>
              </div>
            </div>

            <div data-aos="fade-left" className="col-sm-12 col-lg-6 px-3">
              <div className="single-exp-wrapper">
                <div className="exp-card text-left d-flex justify-content-center">
                  <div className="row">
                    <div className="exp-meta col-lg-12">
                      <img
                        src="./media/tgc.png"
                        className="img-fluid py-4 w-50"
                        alt="job" 
                      />
                      <h5 className="job-client">Full Stack Web Developer & Trainer</h5>
                      <h6 className="job-tenure">Nov 2024 -  Present</h6>
                      {/* <p className="job-tenure"> Speqto Technologies</p> */}
                      <p className="job-tenure"> Delhi</p>
                    </div>
                   {false &&` <div className="exp-details col-lg-8">
                      <h4 className="job-title">Fresher</h4>
                      <p className="exp-description">
                       Curruntly Studing
                      </p>
                      <h6 className="resp-heading bold">Responsibilites</h6>
                      <ul className="exp-resp">
                        <li className="responsibility">
                          Conerting the designs into working site
                        </li>
                        <li className="responsibility">
                          Cleaning existing pages and converting to newer
                          designs
                        </li>
                        <li className="responsibility">
                          Constantly delivering and receiving the feedback
                        </li>
                        <li className="responsibility">
                          Work on the feedback points
                        </li>
                        <li className="responsibility">
                          Resolve any hosting problems
                        </li>
                      </ul>
                    </div>`}
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </>
  );
};

export default Experience;
